const th = {
    common: {
        send: 'ส่งข้อความ',
        ok: "ตกลง",
        admin: 'ผู้ดูแลระบบ',
        login: 'เข้าสู่ระบบ',
        email: 'อีเมล',
        password: 'รหัสผ่าน',
        cancel: 'ยกเลิก',
        delete: 'ลบ',
        search: 'ค้นหา',
        tel: 'โทร',
        fax: 'แฟกซ์',
        submit: 'บันทึก',
        mobile: 'มือถือ',
        address: '176 หมู่ 5 ต.น้ำแพร่ อ.หางดง จ.เชียงใหม่ 50230',
        somethingWrong: 'มีบางอย่างผิดพลาดกรุณาลองใหม่',
        areYouSure: 'คุณแน่ใจที่จะดำเนินการ?',
        areYouSureDelete: "คุณแน่ใจที่จะดำเนินการลบ",
        dropFile: "ลากไฟล์และวางที่นี่ หรือคลิกเพื่อเลือกไฟล์",
        noResultsFound: "ไม่พบข้อมูล",
        close: "ปิด"
    },
    menu: {
        home: 'หน้าแรก',
        product: 'ผลิตภัณฑ์',
        gallery: 'แกลลอรี่',
    },
    enhancedTable: {
        resultNotFound: "ไม่พบข้อมูล",
        rowsPerPage: "จำนวนต่อหน้า:"
    },
    home: {
        secQuote: "บริษัท แวนด้า ซีดส์ จำกัด เป็นบริษัทที่ทำการวิจัยและพัฒนาพันธุ์พืชและได้ดำเนินธุรกิจเกี่ยวกับเมล็ดพันธุ์ โดยการพัฒนาสายพันธุ์ใหม่ที่พร้อมจำหน่ายเมล็ดพันธุ์ทั้งในประเทศและต่างประเทศ สำนักงานตั้งอยู่ที่ ตำบลน้ำแพร่ อำเภอหางดง จ.เชียงใหม่ โดยทีมงานนักวิชาการผู้เชี่ยวชาญการวิจัย ได้รวบรวมความรู้ความสามารถที่มากด้วยประสบการณ์ ในการพัฒนาสายพันธุ์ การผลิตเมล็ดพันธุ์ การพัฒนาการปลูก รวมไปถึงขั้นตอนการจัดเก็บเมล็ดพันธุ์ และการบรรจุภัณฑ์ที่ได้มาตรฐาน โดยทาง บริษัทฯ ได้เล็งเห็นความสำคัญของปัญหาสภาพแวดล้อมในปัจจุบัน จึงนำมาซึ่งความรู้ ความสามารถ พร้อมทั้งประสบการณ์ มาผสมผสานกับเทคโนโลยีสมัยใหม่ ในการวิจัย พัฒนาสายพันธุ์เมล็ดพันธุ์เพื่อเป็นการเพิ่มผลผลิต เพิ่มความต้านทานต่อโรค ปลูกได้ทุกสภาพอากาศ ลดการใช้สารเคมีที่ก่อให้เกิดผลเสียต่อสภาวะแวดล้อม รวมทั้งส่งผลดีต่อเกษตรกรทั้งในด้านการลดต้นทุนการผลิต และผู้บริโภค ทั้งนี้บริษัทฯได้ให้ความสำคัญในทุกด้าน เพื่อเป็นการยกระดับชีวิตความเป็นอยู่ของเกษตรกร และความเป็นสากลของวงการธุรกิจเมล็ดพันธุ์ต่อไป",
        catalogOuote: "ทางเลือกใหม่สำหรับเกษตรกร ที่มีความพึงพอใจต่อเมล็ดภัณฑ์ที่มีคุณภาพ ให้ผลผลิตสูง ภูมิคุ้นกันโรคสูง ลดต้นทุนการผลิต เป็นมิตรกับสิ่งแวดล้อม และเสริมสร้างสุขภาพชีวิตที่ดีของเกษตรกรรวมทั้งผู้บริโภค",
        ourCatalog: "แคตตาล็อก",
        contactUs: "ติดต่อเรา",
        downloadNow: "ดาวน์โหลด",
        name: "ชื่อ",
        email: "อีเมล",
        mobile: "เบอร์โทรศัพท์",
        invalidMobile: "ป้อนเบอร์โทรศัพท์ให้ถูกต้อง",
        message: "ข้อความ",
        nameInvalid: "กรุณากรอกชื่อ",
        emailInvalid: "กรุณากรอกอีเมล",
        phoneNumberInvalid: "กรุณากรอกเบอร์โทรศัพท์",
        siteLink: 'ลิงค์เว็บไซต์',
        followUs: 'ติดตามข่าวสารจากเรา',
        followUsQuote: 'ติดตามข้อมูล ข่าวสาร โปรโมชั่นที่น่าตื่นตาตื่นใจ และข่าวภายในของบริษัทของเราได้',
        saleTeam: 'ฝ่ายขาย'
    },
    adminLogin: {
        forgotPassword: 'ลืมรหัสผ่าน'
    },
    adminMenu: {
        dashboard: "หน้าแรก",
        products: "ผลิตภัณฑ์",
        addProduct: "เพิ่มผลิตภัณฑ์",
        category: "หมวดหมู่ผลิตภัณฑ์",
        addCategory: "เพิ่มหมวดหมู่ผลิตภัณฑ์",
        gallery: "แกลลอรี่",
        users: "ผู้ใช้งาน",
        contacts: "ติดต่อเรา",
        profile: "โพรไฟล์",
        logout: "ออกจากระบบ",
        addUser: "เพิ่มผู้ใช้งาน"
    },
    adminCommon: {
        title: 'ชื่อ',
        invalidTitle: "ป้อนชื่อ",
        lastUpdate: 'อัปเดตล่าสุด',
        description: "คำอธิบาย",
        pleaseSelect: "กรุณาเลือก"
    },
    adminCategory: {
        popular: "โดดเด่น",
        thumbnail: "รูปภาพ",
        createCategory: "สร้างหมวดหมู่ผลิตภัณฑ์"
    },
    adminProduct: {
        createProduct: "สร้างผลิตภัณฑ์",
        categoryTitle: "ชื่อหมวดหมู่ผลิตภัณฑ์",
        invalidCategory: "เลือกหมวดหมู่ผลิตภัณฑ์"
    },
    adminUser: {
        createUser: "สร้างผู้ใช้งาน",
        emailInvalid: "ป้อนอีเมล",
        currentPassword: "รหัสผ่านปัจจุบัน",
        newPassword: "รหัสผ่านใหม่",
        displayName: "ชื่อที่แสดง",
        lastLogin: "เข้าใช้งานล่าสุด",
        invalidDisplayName: "ป้อนชื่อที่แสดง",
        confirmPassword: "ยืนยันรหัสผ่าน",
        passwordInvalid: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร และต้องมี 1 ตัวพิมพ์ใหญ่, 1 ตัวพิมพ์เล็ก, 1 ตัวเลข และ 1 อักขระ",
        passwordInvalid2: "ป้อนรหัสผ่าน",
        passwordInvalid3: "รหัสผ่านไม่ตรงกัน",
        confirmPasswordInvalid: "ป้อนยืนยันรหัสผ่าน",
        changePassword: "เปลี่ยนรหัสผ่าน"
    },
    adminContact: {
        contactName: "ชื่อผู้ติดต่อ",
        contactTel: "เบอร์ติดต่อ",
        contactInfo: "ข้อมูลผู้ติดต่อ",
        contactAt: "วันที่ติดต่อ"
    },
    forgotAndResetPassword: {
        forgotPassword: "ลืมรหัสผ่าน",
        resetPassword: "รีเซ็ตรหัสผ่าน",
    }
}

export default th;